import { render, staticRenderFns } from "./Adminpage.vue?vue&type=template&id=6e19f4c8&"
import script from "./Adminpage.vue?vue&type=script&lang=js&"
export * from "./Adminpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports